import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_LOAD_BALANCER,
  GET_AZURE_LOAD_BALANCER_SUCCESS,
  GET_AZURE_LOAD_BALANCER_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureLoadBalancerList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureLoadBalancerStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_LOAD_BALANCER:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_LOAD_BALANCER_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureLoadBalancerList: action.data,
        error: null,
      };
    case GET_AZURE_LOAD_BALANCER_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
